import * as Blockly from 'blockly/core';
// import { VmtFieldFlyoutText } from '../fields/VmtFlyout/VmtFlyoutEditField';
// import { createMinusField } from '../fields/field_minus';
// import { createPlusField } from '../fields/field_plus';
// import { getExtraBlockState } from '../fields/serialization_helper';
import { Colors } from '../../const';

const REUSABLE_BRICK_COLOR = Colors.REUSABLE_BRICK_COLOR; //'#138D90';

const plusImage =
    'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC' +
    '9zdmciIHZlcnNpb249IjEuMSIgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0Ij48cGF0aCBkPSJNMT' +
    'ggMTBoLTR2LTRjMC0xLjEwNC0uODk2LTItMi0ycy0yIC44OTYtMiAybC4wNzEgNGgtNC4wNz' +
    'FjLTEuMTA0IDAtMiAuODk2LTIgMnMuODk2IDIgMiAybDQuMDcxLS4wNzEtLjA3MSA0LjA3MW' +
    'MwIDEuMTA0Ljg5NiAyIDIgMnMyLS44OTYgMi0ydi00LjA3MWw0IC4wNzFjMS4xMDQgMCAyLS' +
    '44OTYgMi0ycy0uODk2LTItMi0yeiIgZmlsbD0id2hpdGUiIC8+PC9zdmc+Cg==';
/**
 * The parameter block.
 * @type {Blockly.Block}
 */
Blockly.Blocks['vmt_param_drop'] = {
    /**
     * Initializes the block.
     * @this {Blockly.BlockSvg}
     */
    init: function () {
        this.appendDummyInput('NAME')
            .setAlign(Blockly.inputs.Align.RIGHT)
            .appendField(new Blockly.FieldImage(plusImage, 20, 20), 'PLUS');
        // .appendField(new Blockly.FieldImage('https://www.gstatic.com/codesite/ph/images/star_on.gif', 15, 15, { alt: '*', flipRtl: 'FALSE' }));
        this.setOutput(true, null);
        this.setTooltip('');
        this.setHelpUrl('');
        this.setColour(REUSABLE_BRICK_COLOR);

        // set dummy click handler for the plus field
        const plusField = this.getField('PLUS');
        plusField.setOnClickHandler(function () { });
    },
}
